import { apiClient } from './client';
import type {
  DatasetClassificationResult,
  ClassificationTriggerResult,
} from '@/features/classification/types/classification.types';

/**
 * Dataset classification endpoints (#1481).
 *
 * The api client prepends /api/v1/ automatically. The classification router
 * carries its own `/classification` prefix on top of that
 * (api/routes/classification.py), so paths here start at /classification.
 */
export const classificationEndpoints = {
  /**
   * Get the most recent classification result for a dataset.
   *
   * Returns 404 when the dataset has never been classified — callers render
   * the empty state rather than an error.
   */
  getLatest: (datasetId: string) =>
    apiClient.get<DatasetClassificationResult>(
      `/classification/datasets/${datasetId}/classifications/latest`
    ),

  /**
   * Trigger a classification run.
   *
   * Runs synchronously so the refetched result reflects this run; an async
   * run would return a job id and the refetch would show the old verdicts.
   *
   * @param forceRescan - Bypass cached/stored results and re-detect.
   */
  trigger: (
    datasetId: string,
    { forceRescan = true }: { forceRescan?: boolean } = {}
  ) =>
    apiClient.post<ClassificationTriggerResult>(
      `/classification/datasets/${datasetId}/classify`,
      { force_rescan: forceRescan, async_mode: false }
    ),
};
